import { Box, Grid2, Typography } from "@mui/material";
import React from "react";

export default function PaymentSuccessLine({ label = "", value = "" }) {
  return (
    <Box >
      <Grid2 bgcolor="#201E2C" width="100%" p={1} borderRadius="8px" container>
        <Grid2 size={5}>
          <Typography> {label}</Typography>
        </Grid2>
        <Grid2 size={7}>
          <Typography> {value}</Typography>
        </Grid2>
      </Grid2>
    </Box>
  );
}
